import { render } from "./ChaNav.vue?vue&type=template&id=da5024b6&scoped=true"
import script from "./ChaNav.vue?vue&type=script&lang=js"
export * from "./ChaNav.vue?vue&type=script&lang=js"

import "./ChaNav.vue?vue&type=style&index=0&id=da5024b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da5024b6"]])

export default __exports__